import React from "react";
import { LegalLayout } from "./LegalLayout";

export default function TermsOfPaidServices() {
  return (
    <LegalLayout
      slug="terms-paid-services"
      title="Terms of Paid Services"
      lastUpdated="September 08, 2026"
      sections={[
        { heading: "Scope", body: [
          `These terms apply to any paid feature of AdGen Store (https://adgen.store), including credit purchases, subscriptions, and auto-pay mandates. They supplement — and, where inconsistent, prevail over — our general Terms of Service for matters relating to payment. These terms are governed by the laws of India.`,
        ]},
        { heading: "Billing & Payment Methods", body: [
          `Payments are processed by third-party providers such as Stripe and Razorpay. AdGen Store does not store your full card or bank details. [PLACEHOLDER — confirm exact payment processors and update if this changes.]`,
          `[PLACEHOLDER — describe supported currencies, tax handling, and invoicing practices once finalized.]`,
        ]},
        { heading: "Subscriptions & Auto-Renewal", body: [
          `Subscription plans, including Razorpay Autopay mandates, renew automatically at the end of each billing period unless cancelled before the renewal date.`,
          `You may cancel your subscription at any time from your account settings; cancellation will take effect at the end of the current billing period. [PLACEHOLDER — describe cancellation deadlines, proration rules, and how mandate revocation with Razorpay is handled.]`,
        ]},
        { heading: "Refund Policy", body: [
          `Paid credits and subscription fees are generally non-refundable, except where required by applicable law.`,
          `[PLACEHOLDER — describe any exceptions, such as accidental double-charges, verified billing errors, or service outage credits, and the process for requesting them.]`,
        ]},
        { heading: "Failed Payments", body: [
          `If a scheduled payment fails, we may retry the charge and may temporarily suspend paid features until the outstanding balance is settled. [PLACEHOLDER — specify retry schedule and suspension timeline.]`,
        ]},
        { heading: "Price Changes", body: [
          `We may change the price of paid features, credit packs, or subscription plans with advance notice. Continued use of paid features after a price change takes effect constitutes acceptance of the new pricing. [PLACEHOLDER — specify minimum notice period.]`,
        ]},
        { heading: "Taxes", body: [
          `Prices may be subject to applicable Indian taxes, including GST, which will be calculated and displayed at checkout where applicable. [PLACEHOLDER — confirm GST registration status and exact tax treatment with an accountant/legal counsel.]`,
        ]},
        { heading: "Chargebacks", body: [
          `Initiating a chargeback or payment dispute without first contacting us at adgenstore@gmail.com may result in immediate suspension of your account and reversal of associated credits. [PLACEHOLDER — replace with reviewed legal text describing full chargeback handling process.]`,
        ]},
        { heading: "Contact", body: [
          `Name : AdGen Store Team\nAddress: Sunworld Arista, Sector-168, Noida, Uttar Pradesh, India\nEmail: adgenstore@gmail.com`,
        ]},
      ]}
    />
  );
}
